import { Chip } from '@mui/material';

import { type SapStatus, type VivaStatus } from '../../../dtos';
import { determineStatusText } from '../../../utils';
import { content } from '../../../utils/content';

type VaStatusChipProps = {
  readonly sapStatus: SapStatus | null;
  readonly vivaStatus: VivaStatus | null;
};

export const VaStatusChip = ({ sapStatus, vivaStatus }: VaStatusChipProps) => {
  const status = determineStatusText(sapStatus, vivaStatus);
  return (
    <Chip
      variant="tag"
      color="primary"
      label={status}
      title={vivaStatus ? content.vivaStatus[vivaStatus] : undefined}
    />
  );
};
